var map = {
	"./Article": 3678,
	"./Article/": 3678,
	"./Article/index": 3678,
	"./Article/index.jsx": 3678,
	"./Article/styles.module.css": 574,
	"./FeaturesLayout": 5919,
	"./FeaturesLayout/": 5919,
	"./FeaturesLayout/index": 5919,
	"./FeaturesLayout/index.jsx": 5919,
	"./FeaturesLayout/styles.module.css": 9576,
	"./FooterLayout": 3444,
	"./FooterLayout/": 3444,
	"./FooterLayout/index": 3444,
	"./FooterLayout/index.jsx": 3444,
	"./FooterLayout/styles.module.css": 2113,
	"./HeroLayout": 4142,
	"./HeroLayout/": 4142,
	"./HeroLayout/index": 4142,
	"./HeroLayout/index.jsx": 4142,
	"./HeroLayout/styles.module.css": 2803,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9077;